import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { ButtonWithText } from "../../utils/ButtonWithText";
import { NewCardContainer } from "./NewCardContainer";
import { SettingsLayer } from "./SettingsLayer";
import { SplashBackground } from "./SplashBackground";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;

    public settingsLayer: SettingsLayer;

    constructor() {

        super("SplashScene");
    }

    public create(data: any): void {

        SplashScene.currentInstance = this;

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        this.settingsLayer = null;

        GameManager.setCurrentScene(this);

        if (!this.anims.exists("chest_hover_fx")) {
            this.anims.create(
                {
                    key: "chest_hover_fx", 
                    frames: this.anims.generateFrameNames("texture_atlas_2", {prefix: "fx_hover_chest_", start: 1, end: 24, zeroPad: 2, suffix: ""}), 
                    frameRate: 24,
                    repeat: -1
                }
            );
        }

        const tmpBackground = this.add.graphics();
        tmpBackground.fillStyle(0x000000);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        const background = new SplashBackground(this);
        this.add.existing(background);


        const copyrightLabel = this.add.text(GameConstants.GAME_WIDTH - 8, 22 * GameVars.scaleY, "a game by ravalmatic", {fontFamily: "Arial", color: "#ffffff", fontSize: "16px"});
        copyrightLabel.setOrigin(1);
        copyrightLabel.alpha = .4;
        copyrightLabel.scaleY = GameVars.scaleY;

        const creditsLabel = this.add.text(GameConstants.GAME_WIDTH - 8, 40 * GameVars.scaleY, "inspired by card crawl", {fontFamily: "Arial", color: "#ffffff", fontSize: "16px"});
        creditsLabel.setOrigin(1);
        creditsLabel.alpha = .4;
        creditsLabel.scaleY = GameVars.scaleY;

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleY = GameVars.scaleY;

        const settingsButton = new Button(this, 55, 55 * GameVars.scaleY, "texture_atlas_1", "btn_settings", "btn_settings");
        settingsButton.scaleY = GameVars.scaleY;
        settingsButton.onDown(this.onClickSettings, this);
        settingsButton.setInflationTween(1.1);
        this.add.existing(settingsButton);

        const title = new Phaser.GameObjects.Image(this, -15, -350, "texture_atlas_1", "game_title");
        scaledItemsContainer.add(title);

        const knight = new Phaser.GameObjects.Image(this, -60, 10, "texture_atlas_1", "knight");
        scaledItemsContainer.add(knight);

        let chestFX = this.add.sprite(0, 150, "texture_atlas_2", "fx_hover_chest_01");
        chestFX.play("chest_hover_fx");
        chestFX.setScale(.55);
        scaledItemsContainer.add(chestFX);

        chestFX = this.add.sprite(10, 135, "texture_atlas_2", "fx_hover_chest_01");
        chestFX.play("chest_hover_fx");
        chestFX.alpha = .45;
        chestFX.setScale(-.3, .85);
        scaledItemsContainer.add(chestFX);

        const playButtonLabel = new Phaser.GameObjects.Text(this, 0, -4, text.PLAY[lan], {fontFamily: "AlmendraBold", color: "#663227", fontSize: "46px"});
        playButtonLabel.setOrigin(.5);

        if (playButtonLabel.width > 115) {
            playButtonLabel.scale = 115 / playButtonLabel.width;
        }

        const playButtonImage = new Phaser.GameObjects.Image(this, 0, 0, "texture_atlas_1", "btn_next_game_over");
        playButtonImage.setScale(.85);

        const playButton = new ButtonWithText(this, playButtonImage, playButtonLabel, this.onClickPlay, this);
        playButton.x = 225;
        playButton.y = 325;
        scaledItemsContainer.add(playButton);

        const newCardContainer =  new NewCardContainer(this);
        this.add.existing(newCardContainer);

        if (data.fromLanguageSelection) {

            this.onClickSettings();

        } else {
            if (data.fromShopScene) {
                this.cameras.main.fadeIn(150, 255, 255, 255);
            } else {
                this.cameras.main.fadeIn(750, 0, 0, 0);
            }
        }


        const logo = this.add.image(10, GameConstants.GAME_HEIGHT - 100 * GameVars.scaleY, "logo");
        logo.setOrigin(0, .5);
        logo.setScale(.65, .65 * GameVars.scaleY);

        AudioManager.stopSound("soundtrack_loop");
        AudioManager.stopSound("splash_loop");
        AudioManager.stopSound("victory_loop");
        AudioManager.stopSound("gameover_loop");
        AudioManager.playSound("splash_loop", true, 2);
    }

    public hideSettingsLayer(): void {  

        this.time.delayedCall(60, () => {
            this.settingsLayer.destroy();
            this.settingsLayer = null;
        }, [], this);
    }

    private onClickPlay(): void {

        if (this.settingsLayer) {
            return;
        }
    
        GameManager.enterBoardScene();

        AudioManager.playSound("btn_play_click");
    }

    private onClickSettings(): void {

        if (this.settingsLayer) {
            return;
        }

        this.settingsLayer = new SettingsLayer(this);
        this.add.existing(this.settingsLayer);

        AudioManager.playSound("btn_click");
    }
}
